import { createAction } from '@ngrx/store';

export const logout = createAction(
  '[Users] logout request'
);